import * as React from 'react';
import { JSSClassesProps } from 'react-jss';
import { ComponentJSSClasses } from './styles';

export interface TagCheckboxProps {
    inputName?: string;
    disabled?: boolean;
    checked: boolean;
    label: string | number;
    onChange: (value: any) => void;
    borderColor?: string;
    children?: JSX.Element;
    wrapperClassName?: string;
    innerClassName?: string;
}

interface StyledTagCheckboxProps extends JSSClassesProps<ComponentJSSClasses>, TagCheckboxProps {}

export const TagCheckbox = (props: StyledTagCheckboxProps) => {
    const {
        classes,
        checked,
        disabled,
        onChange,
        label,
        inputName,
        borderColor,
        wrapperClassName,
        innerClassName,
    } = props;

    return (
        <label className={`${classes.label} ${wrapperClassName ? wrapperClassName : ''}`}>
            <input
                type="checkbox"
                checked={checked}
                disabled={disabled}
                className={classes.input}
                onChange={() => onChange(label)}
            />

            <span
                className={`${classes.tag} ${innerClassName ? innerClassName : ''} ${
                    checked ? classes.tagActive : ''
                }`}
                style={{ borderColor: (checked ? '#3D95FB' : borderColor) || '#E6E6E6'}}
            >
                {inputName ? inputName : null}
                {props.children}
            </span>
        </label>
    );
};
